export default __webpack_public_path__ + "static/media/generate_active.80676f07.svg";